import { styled } from "goober";
import type { CSSProperties } from "react";
import type { ListStatus, StatusFilterValue } from "./BuildStatusState";
import { StatusIndicator } from "./StatusIndicator";
import { Text } from "./Text";

export {
  getBranchListStatus,
  getWorkflowListDraft,
  type StatusFilterValue,
  statusFilterLabels,
  statusFilterOrder,
} from "./BuildStatusState";

const Container = styled("div")`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const statusConfig = {
  thinking: { label: "3B is thinking" },
  building: { label: "3B is building" },
  waiting: { label: "3B needs you" },
  ready: { label: "Ready" },
} as const;

type Props = {
  status: ListStatus;
};

export function BuildStatus({ status }: Props) {
  if (!status) return null;

  const { label } = statusConfig[status];

  return (
    <Container>
      <StatusIndicator state={status} focused />
      <Text variant="text-small" color="var(--text-secondary)" ellipsis>
        {label}
      </Text>
    </Container>
  );
}

const scaleStyle = (factor: number): CSSProperties => ({
  transform: `scale(${factor})`,
  transformOrigin: "center",
});

export function StatusFilterMenuLeft({
  status,
}: {
  status: StatusFilterValue;
}) {
  return (
    <div style={scaleStyle(0.8)}>
      <StatusIndicator state={status} focused />
    </div>
  );
}

export function StatusFilterPillLeft({
  status,
}: {
  status: StatusFilterValue;
}) {
  return (
    <div style={scaleStyle(0.6)}>
      <StatusIndicator state={status} focused />
    </div>
  );
}
